import React, { useEffect } from 'react';

import { useCookieConsent } from '../hooks/useCookieConsent';
import { initGoogleAnalytics, setAnalyticsConsent } from '../utils/gtag';

/**
 * Loads Google Analytics 4 on every production visit using Consent Mode v2.
 * Analytics starts "denied" (cookieless pings still reach GA4 so traffic is
 * counted), then upgrades to "granted" once the user accepts analytics cookies.
 */
const GoogleAnalyticsLoader: React.FC = () => {
  const { consentState } = useCookieConsent();

  // Initialize once on mount — gtag loads immediately with denied-by-default consent.
  useEffect(() => {
    initGoogleAnalytics({ analyticsGranted: consentState.analytics });
    // Intentionally run once; consent changes are handled by the effect below.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Reflect the user's analytics choice into GA Consent Mode whenever it changes.
  useEffect(() => {
    if (consentState.hasInteracted) {
      setAnalyticsConsent(consentState.analytics);
    }
  }, [consentState.hasInteracted, consentState.analytics]);

  return null;
};

export default GoogleAnalyticsLoader;
